module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><path d=\"M10 13.236h1a.994.994 0 0 1 1 1v3a.995.995 0 0 0 1 1h2a2.02 2.02 0 0 0 2-2v-5a2.082 2.082 0 0 0 2-2 2.39 2.39 0 0 0-1-2l-7-5a1.554 1.554 0 0 0-1.002-.472h.004A1.554 1.554 0 0 0 9 2.236l-7 5a2.39 2.39 0 0 0-1 2 2.082 2.082 0 0 0 2 2v5a2.02 2.02 0 0 0 2 2h2a.995.995 0 0 0 1-1v-3a.994.994 0 0 1 1-1h1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-address.svg
// module id = 246
// module chunks = 1